import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';

import { ApiService } from '../services/api.service';

export const AUTH_GUARD: CanActivateFn = () => {
  const API_SERVICE = inject(ApiService);
  const ROUTER = inject(Router);

  if (API_SERVICE.isLoggedIn()) {
    ROUTER.navigate(['/main']);
    return false;
  }
  return true;
};
